<template>
  <div class="app-shell">
    <NavBar class="no-print" v-if="showNav" />

    <main :class="['app-main', { 'app-main--plain': !showNav }]">
      <!-- La clase content-page se mantiene para no romper vistas existentes -->
      <router-view class="content-page" />
    </main>

    <AppFooter v-if="showNav" />
  </div>
</template>

<script>
import NavBar from '@/components/navbar/NavBar.vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    NavBar,
    AppFooter,
  },
  computed: {
    ...mapState(['role', 'user', 'roleToken']),

    showNav() {
      const hideNavRoutes = [
        /^\/login$/,
        /^\/registrarse$/,
        /^\/solicitar-recuperacion$/,
        /^\/expired-recovery$/,
        /^\/cambiar_pass$/,
        /^\/magic-link-login(\/[\w-]+)?$/,
      ];

      const currentPath = this.$route.path;
      const isRouteHidden = hideNavRoutes.some((regex) => regex.test(currentPath));
      const user = this.user;

      // Nav (y footer) solo cuando:
      // - no estamos en rutas de auth
      // - no es NotFound
      // - hay usuario logueado con token
      return !isRouteHidden && this.$route.name !== 'NotFound' && user && user.token;
    },
  },
  mounted() {
    // Protección de rutas con meta.requiresAuth
    const requiresAuth = this.$route.matched.some((record) => record.meta.requiresAuth);
    if (requiresAuth && (!this.user || !this.user.token)) {
      this.$router.push('/login');
    }

    // Refresco de rol si tenemos roleToken cacheado
    // if (this.roleToken) {
    //   this.$store.dispatch('fetchRole').then(() => {
    //     this.$store.dispatch('startRoleAutoRefresh');
    //   });
    // }
  },
};
</script>

<style lang="scss">
#app {
  min-height: 100vh;
}

.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(circle at 0% 0%, rgba(148, 163, 184, 0.18), transparent 40%),
    radial-gradient(circle at 100% 0%, rgba(56, 189, 248, 0.08), transparent 45%),
    linear-gradient(180deg, #020617 0%, #020617 55%, #020617 100%);
  color: #e5e7eb;
}

/* Contenedor general de las vistas */
.app-main {
  flex: 1;
  padding-top: 56px; /* altura del NavBar */
  padding-bottom: 44px; /* altura del footer */
}

/* Cuando no hay Nav (login, registro...) quitamos paddings */
.app-main--plain {
  padding-top: 0;
  padding-bottom: 0;
}

/* La vista interna decide si quiere centrar o no, aquí solo damos ancho y altura min */
.content-page {
  width: 100%;
  min-height: calc(100vh - 56px - 44px);
}

/* Eliminamos estilos antiguos del nav global */
nav {
  padding: 0;
}
</style>
